import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AdvisorId } from "../../Types";
import ValidationError from "../../ZodError";
const AlmaMaters = z.object({
    degrees: z.array(z.object({
        college: z.string().nullable(),
        degree: z.string().nullable(),
    })),
});
export const FartherEmployeeV2 = z.object({
    personId: AdvisorId,
    headshotPath: z.string().url().nullable(),
    description: z.string().nullable(),
    calendarUrl: z.string().url().nullable(),
    linkedinUrl: z.string().url().nullable(),
    concentration: z.string().nullable(),
    alma_maters: AlmaMaters.nullable(),
    hometown: z.string().nullable(),
    experience_start_year: z.number().int().nullable(),
    funFacts: z.string().nullable(),
    pershingRRcode: z.string().nullable(),
    location: z.string().nullable(),
    isAdmin: z.boolean(),
    isAvailable: z.boolean(),
    createdTs: z.string().nullable(),
    modifiedTs: z.string().nullable(),
});
export const Response = FartherEmployeeV2;
const url = () => {
    return environment() === "PROD"
        ? "https://middleware.prod.farther.com/entity/v2/entity/farther-employee"
        : "https://middleware.uat.farther.com/entity/v2/entity/farther-employee";
};
export default async function postFartherEmployeeV2(req, config) {
    const formData = new FormData();
    formData.append("information", JSON.stringify({
        first: req.information.first,
        last: req.information.last,
        email: req.information.email,
        description: req.information.description,
        calendarUrl: req.information.calendarUrl,
        linkedinUrl: req.information.linkedinUrl,
        concentration: req.information.concentration,
        almaMaters: req.information.almaMaters,
        hometown: req.information.hometown,
        experienceStartYear: req.information.experienceStartYear,
        funFacts: req.information.funFacts,
        pershingRRCode: req.information.pershingRRCode,
        location: req.information.location,
    }));
    formData.append("organization", JSON.stringify(req.organization));
    formData.append("roles", JSON.stringify(req.roles));
    if (req.teamIds) {
        formData.append("teamIds", JSON.stringify(req.teamIds));
    }
    if (req.headshot) {
        formData.append("headshot", req.headshot);
    }
    const { data } = await axios.postForm(url(), formData, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[${postFartherEmployeeV2.name}] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postFartherEmployeeV2.js.map